import React from 'react';
import { Button, Icon } from 'antd';

function ButtonCustom({ style, onClick, color, label, size, borderRadius, icon, positionIcon, fontSize = "14", iconColor = "white", fontWeight = "Regular", iconSize = "14", iconImage, textAlign = "center", iconButton, className, hoverThis, ...rest }) {

    return (
        <Button {...rest}  className={`button ${color ? color : ''} radius${borderRadius ? borderRadius : ''} ${size ? size : ''} font-size${fontSize} ${fontWeight} iconSize${iconSize} iconColor${iconColor} textAlign-${textAlign} ${iconButton ? 'iconButton' : ''} ${className ? className : ''} ${hoverThis ? 'button-shadow' : ''}`}
            size={size === "extra" ? 'default' : size}
            icon={positionIcon === "right" ? '' : icon}
            onClick={onClick}
            style={style ? style : null}
        >
            {iconImage ? <img className={`button-icon ${positionIcon === "right" ? 'right' : ''}`} src={`/resources/images/${iconImage}`} alt="" /> : ''}
            {label} {positionIcon === "right" ? <Icon type={icon} /> : ''}
        </Button>
    );
}

export default ButtonCustom;